export class TimeslotsConstants {

  public static readonly UNAVAILABLE_TIMESLOT: number = -1;
  public static readonly AVAILABLE_TODAY: number = 0;
  public static readonly AVAILABLE_TOMORROW: number = 1;
  public static readonly AVAILABLE_DAY_AFTER_TOMORROW: number = 2;
}
